import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-CloseShape",
  "use": "svg-icon-CloseShape-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"svg-icon-CloseShape\"><path d=\"M14.744 13.506a.875.875 0 1 1-1.238 1.238L8 9.237l-5.506 5.507a.875.875 0 1 1-1.238-1.238L6.763 8 1.256 2.494a.875.875 0 1 1 1.238-1.238L8 6.763l5.506-5.507a.875.875 0 1 1 1.238 1.238L9.237 8l5.507 5.506z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol